module.exports = __webpack_public_path__ + "static/media/overTime@2x.ada52ace.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/overTime@2x.png
// module id = 1130
// module chunks = 0